import {
  Component,
  Host,
  h,
  Prop,
  Element,
  Event,
  EventEmitter,
  State
} from "@stencil/core";

import { MercuryBundles } from "@genexus/mercury";
import {
  ActionListModel,
  ActionListItemModelExtended
} from "@genexus/chameleon-controls-library";

import { Locale } from "../../../common/locale";
import { mapCommentsToActionListModel } from "./helpers/mapCommentsToActionListModel";

const CSS_BUNDLES: MercuryBundles = [
  // Use only the bundles that are needed for this component.
  "resets/box-sizing",
  "components/button",
  "components/list-box",
  "utils/layout",
  "utils/spacing"
];
@Component({
  tag: "gx-ide-team-dev-select-recent-comment",
  styleUrl: "select-recent-comment.scss",
  shadow: true,
  assetsDirs: ["gx-ide-assets/team-dev-select-recent-comment"]
})
export class GxIdeTeamDevSelectRecentComment {
  /**
   * The component hard-coded strings translations.
   */
  private _componentLocale: any;
  private selectedComment: string = null;

  @Element() el: HTMLGxIdeTeamDevSelectRecentCommentElement;

  /**
   * Recent comments list
   */
  @Prop() readonly comments: string[];

  /**
   * The comments model as ActionListModel, which is the model the ch-action-list expects
   */
  @State() commentsActionList: ActionListModel = [];

  /**
   * Callback invoked when user confirms selection
   */
  @Prop() readonly confirmCallback: confirmCallback;

  /**
   * Callback invoked when user cancel selection
   */
  @Prop() readonly cancelCallback: cancelCallback;

  /**
   * @description Gets fired when the component has rendered for the first time.
   */
  @Event() componentDidRenderFirstTime: EventEmitter<string>;

  async componentWillLoad() {
    this._componentLocale = await Locale.getComponentStrings(this.el);
    this.commentsActionList = mapCommentsToActionListModel(this.comments);
  }

  private commentSelectionChangedHandler = (
    event: CustomEvent<ActionListItemModelExtended[]>
  ) => {
    if (event.detail.length > 0) {
      this.selectedComment = event.detail[0].item.id;
    }
  };

  private confirmCallbackHandle = async () => {
    await this.confirmCallback(this.selectedComment);
  };

  private cancelCallbackHandle = async () => {
    await this.cancelCallback();
  };

  render() {
    return (
      <Host class="widget">
        <ch-theme model={CSS_BUNDLES}></ch-theme>
        <section class="section">
          <div class="main">
            <ch-action-list-render
              class="list-box recent-comments-list"
              selection="single"
              model={this.commentsActionList}
              onSelectedItemsChange={this.commentSelectionChangedHandler}
            ></ch-action-list-render>
          </div>

          <footer class="footer dialog-footer-with-border spacing-body-block-end spacing-body-inline">
            <div class="buttons-spacer">
              <button
                class="button-secondary"
                id="button-cancel"
                onClick={this.cancelCallbackHandle}
                part="button-cancel"
              >
                {this._componentLocale.cancelButton}
              </button>
              <button
                class="button-primary"
                id="button-confirm"
                onClick={this.confirmCallbackHandle}
                part="button-confirm"
              >
                {this._componentLocale.confirmButton}
              </button>
            </div>
          </footer>
        </section>
      </Host>
    );
  }
}
export type confirmCallback = (comment: string) => Promise<void>;
export type cancelCallback = () => Promise<void>;
